import { init as initApm } from '@elastic/apm-rum';

export const validateElasticApm = () => {
  const eapm = window?.elasticApm;
  return eapm;
};

export const initializeElasticApm = (
  eapm,
  { serverUrl, environment, serviceName, options }
) => {
  if (!eapm?.isInitialized) {
    const initializedEapm = initApm({
      serverUrl,
      environment,
      serviceName,
      ...(options && { ...options }),
    });
    return initializedEapm;
  }
  return eapm;
};

export const validateAndInitializeElasticApm = (initParams) => {
  const eapm = validateElasticApm();
  return initializeElasticApm(eapm, { ...initParams });
};

export const addElasticApmLabels = (tag) => {
  const eapm = validateElasticApm();

  const { transaction } = tag;
  if (eapm && transaction) {
    transaction.addLabels({ ...tag.data });

    if (transaction.type === 'http-request') {
      transaction.outcome =
        tag.data.result === 'error' && transaction.type === 'http-request'
          ? 'failure'
          : 'success';
    }
  }
};
